import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistReducer, persistStore } from 'redux-persist';
import sessionStorage from 'redux-persist/es/storage/session';

import { authApi } from 'services/authApi';
import { entityApi } from 'services/entityApi';
import { metadataApi } from 'services/metadataApi';
import { applicationApi } from 'services/applicationApi';
import { analyticsApi } from 'services/analyticsApi';

import authSlice from 'slice/authSlice';
import searchReducer from 'slice/searchSlice';
import appReducer from 'slice/appSlice';
import fileViewerReducer from 'slice/fileViewerSlice';
import { entityParameterApi } from 'services/entityParameterApi';

const authPersistConfig = {
  key: 'auth',
  storage: sessionStorage
};

const searchPersistConfig = {
  key: 'search',
  storage: sessionStorage
};

const fileViewerPersistConfig = {
  key: 'fileViewer',
  storage: sessionStorage
};

const reducers = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  // Add the generated reducer as a specific top-level slice
  [authApi.reducerPath]: authApi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [applicationApi.reducerPath]: applicationApi.reducer,
  [entityApi.reducerPath]: entityApi.reducer,
  [entityParameterApi.reducerPath]: entityParameterApi.reducer,
  [metadataApi.reducerPath]: metadataApi.reducer,
  app: appReducer,
  search: persistReducer(searchPersistConfig, searchReducer),
  fileViewer: persistReducer(fileViewerPersistConfig, fileViewerReducer)
});

const store = configureStore({
  reducer: reducers,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false }),
    authApi.middleware,
    analyticsApi.middleware,
    applicationApi.middleware,
    entityApi.middleware,
    entityParameterApi.middleware,
    metadataApi.middleware
  ],
  devTools: true
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store;
export const persistor = persistStore(store);
